'use client'

import { logOut } from '@/actions'
import { useClearCachingPromotion } from '@/features/coupon/hooks/use-promotion'
import { useAccountStore, useCartStore } from '@/store'
import { useUpsellStore } from '@/store/upsell'
import { DEFAULT_LOGOUT_REDIRECT } from '@/utils/routes'
import { useQueryClient } from '@tanstack/react-query'
import { useRouter } from 'next/navigation'
import { useState } from 'react'
import { toast } from 'react-toastify'

export const useLogout = () => {
  // State
  const [isLoading, setIsLoading] = useState(false)
  const queryClient = useQueryClient()

  // Store và Router
  const { clearUser } = useAccountStore()
  const { clearCart, refetchCart } = useCartStore()
  const router = useRouter()
  const { clear: clearPromotion } = useClearCachingPromotion()
  const { clearOrderCode } = useUpsellStore()
  // Hàm logout
  const logout = async () => {
    try {
      setIsLoading(true)

      // Gọi API logout từ server action
      const res = await logOut()

      // Xử lý lỗi từ response
      if (res?.status === 'error') {
        toast.error(res?.message)
        return
      }
    } catch (error) {
      // Xử lý lỗi khi gọi logOut
      console.error('Logout error:', error)
    } finally {
      clearPromotion()
      // Xoá dữ liệu user và cart từ store
      clearUser()
      clearCart()
      clearOrderCode()
      await refetchCart()
      // Xoá cache của React Query
      queryClient.clear()
      // Redirect sau khi logout thành công
      router.push(DEFAULT_LOGOUT_REDIRECT)
      setIsLoading(false)
    }
  }

  return {
    logout,
    isLoading,
  }
}
